import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=0033ac6a&"
import script from "./horizontal-nav.vue?vue&type=script&lang=js&"
export * from "./horizontal-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports